import React from 'react'
import './profile.scss'

export const Profile = () => {
  return (
    <div className="main">
      <div className="container">
        <div className="content">
          <div className="heading">
            <h3>Profile</h3>
          </div>
        </div>
      </div>
    </div>
  )
}
